import React, { Component } from 'react';
import { TextField } from '@mui/material';
import _ from 'lodash';

import FirstColumnContainer from './FirstColumnContainer';
import Question from './Question';
import { integerPercentageShape } from '../../../types';

export default class IntegerPercentage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: _.times(props.numCases, () => ''),
    };
  }

  getAdditionalValue = (caseIndex) => (
    this.props.answerPayload && this.props.answerPayload.answers[caseIndex]
      ? this.props.answerPayload.answers[caseIndex].answer
      : this.state.answers[caseIndex]);

  setAdditional = (caseIndex, value) => {
    const answers = this.state.answers.slice();
    answers[caseIndex] = value;

    this.setState({
      answers,
    });
  };

  checkIfDisabled = (sampleIndex) => {
    const condition = this.props.disableIf;
    if (!condition) {
      return false;
    }

    const answers = this.props.getSubmissionAnswer(condition.question);
    if (!answers || !answers[sampleIndex]) {
      return false;
    }
    const { answer } = answers[sampleIndex]; // OneOf answer has this shape
    switch (condition.operation) {
      case 'equal':
        return answer === condition.value;
      case 'unequal':
        return answer !== condition.value;
      case 'in':
        return condition.value.indexOf(answer) !== -1;
      default:
        throw Error(condition, 'The operation is not supported');
    }
  };

  renderAdditional(question, sampleIndex, placeholder) {
    const value = this.getAdditionalValue(sampleIndex);
    // eslint-disable-next-line no-restricted-globals
    const validInput = !isNaN(value) && Math.floor(value) === Number(value);
    return (
      <TextField
        style={{ width: 'auto' }}
        inputStyle={{ textAlign: 'center' }}
        key={`${question.uuid}-${sampleIndex}`}
        id={`additionalQuestion-${question.uuid}-${sampleIndex}`}
        placeholder={placeholder || '%'}
        disabled={this.checkIfDisabled(sampleIndex)}
        value={value}
        variant="standard"
        errorText={!validInput}
        onChange={(e) => {
          this.setAdditional(
            sampleIndex,
            e.target.value,
          );
          this.props.onSamplePayloadChanged(
            question.uuid,
            sampleIndex,
            { type: 'IntegerPercentage', answer: e.target.value },
          );
        }}
      />
    );
  }

  renderAdditionals(question, questionStyle, placeholder) {
    return (
      <div key={question.uuid} className="mb4 mt4">
        <div className="flex mb2 nowrap">
          <FirstColumnContainer style={{ whiteSpace: 'pre-wrap' }} className="flex flex-column justify-center">
            {
              questionStyle
                ? <Question question={question.text} />
                : <span className="fw3">{question.text}</span>
            }
          </FirstColumnContainer>
          <ul className="flex ma0 list nowrap pl0 basis-100">
            {
              _.map(_.keys(this.state.answers), (sampleIndex) => (
                <li
                  key={`${question.uuid}-${sampleIndex}`}
                  className="mr2 basis-100 w2 flex justify-center"
                >
                  {this.renderAdditional(question, sampleIndex, placeholder)}
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const { question, questionStyle, placeholder } = this.props;
    return (
      <div>
        {this.renderAdditionals(question, questionStyle, placeholder)}
      </div>
    );
  }
}

IntegerPercentage.propTypes = integerPercentageShape.isRequired;
